import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import NavigationBar from "../layout/NavigationBar";
import Footer from "../layout/footer";
import "datatables.net-dt/css/jquery.dataTables.css";

function OrderManagementview() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const EventId = searchParams.get("id");
    const [eventDetails, setEventDetails] = useState(null);
    const [greetingCardDetails, setGreetingCardDetails] = useState([]);
    const [giftDetails, setGiftDetails] = useState([]);
    const [deliveryForm, setDeliveryForm] = useState({
        delivery_status: 'ordered',
        estimated_delivery_date: '',
        tracking_number: '',
        courier_service: '',
        courier_tracking_url: '',
        pickup_address: '',
        business_contact: '',
        location_notes: '',
        shipped_from: {
            business_name: '',
            address: '',
            city: '',
            state: '',
            zip_code: '',
            phone: ''
        }
    });

    const updateDeliveryStatus = async () => {
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_APIURL}event/update-delivery-status`,
                {
                    event_id: EventId,
                    delivery_status: deliveryForm.delivery_status,
                    estimated_delivery_date: deliveryForm.estimated_delivery_date,
                    tracking_number: deliveryForm.tracking_number,
                    courier_service: deliveryForm.courier_service,
                    courier_tracking_url: deliveryForm.courier_tracking_url,
                    pickup_address: deliveryForm.pickup_address,
                    business_contact: deliveryForm.business_contact,
                    location_notes: deliveryForm.location_notes,
                    shipped_from: deliveryForm.shipped_from
                }
            );

            if (response.data.status === 'success') {
                alert('Order status updated successfully');
                fetchData();
            }
        } catch (error) {
            console.error('Error updating order status:', error);
            alert('Failed to update order status');
        }
    };
    useEffect(() => {
        if (!EventId) {
            navigate(`/ordermanagement`);
        } else {
            fetchData();
        }
    }, [EventId]);

    useEffect(() => {
        if (eventDetails) {
            setDeliveryForm({
                delivery_status: eventDetails.current_tracking_status || 'ordered',
                estimated_delivery_date: eventDetails.estimated_delivery_date
                    ? new Date(eventDetails.estimated_delivery_date).toISOString().slice(0, 16)
                    : '',
                tracking_number: eventDetails.tracking_number || '',
                courier_service: eventDetails.courier_service || '',
                courier_tracking_url: eventDetails.courier_tracking_url || '', // Fixed this line
                pickup_address: eventDetails.pickup_address || '',
                business_contact: eventDetails.business_contact || '',
                location_notes: eventDetails.location_notes || '',
                shipped_from: eventDetails.shipped_from || {
                    business_name: '',
                    address: '',
                    city: '',
                    state: '',
                    zip_code: '',
                    phone: ''
                }
            });
        }
    }, [eventDetails]);

    const fetchData = () => {
        axios
            .get(`${process.env.REACT_APP_APIURL}event/list?event_id=${EventId}`)
            .then((res) => {
                if (res.data.status === "success") {
                    setEventDetails(res.data.result);
                    fetchGreetingAndGiftDetails(res.data.result.cart);
                }
            })
            .catch((err) => {
                console.error("Error fetching events:", err);
            });
    };


    const fetchGreetingAndGiftDetails = (cartItems) => {
        const greetingCardIds = cartItems
            .filter((item) => item.greeting_card)
            .map((item) => {
                return {
                    greeting_card: item.greeting_card,
                    order_data_count: item.order_data_count,
                };
            });

        const giftIds = cartItems
            .filter((item) => item.gift)
            .map((item) => {
                return {
                    gift: item.gift,
                    order_data_count: item.order_data_count,
                };
            });

        console.log(greetingCardIds);
        console.log(giftIds);

        // Create arrays to store the results
        let greetingCards = [];
        let gifts = [];

        // Fetch greeting cards data
        const greetingCardPromises = greetingCardIds.map((item) => {
            return axios
                .get(`${process.env.REACT_APP_APIURL}greeting/list?greeting_id=${item.greeting_card}`)
                .then((res) => {
                    const updatedResult = {
                        ...res.data.result,
                        orderCount: item.order_data_count,  // Add item.order to the response
                    };
                    greetingCards.push(updatedResult); // Collect results
                })
                .catch((err) => {
                    console.error("Error fetching greeting card details for ID:", item.greeting_card, err);
                });
        });

        // Fetch gift data
        const giftPromises = giftIds.map((item) => {
            return axios
                .get(`${process.env.REACT_APP_APIURL}gift/list?gift_id=${item.gift}`)
                .then((res) => {
                    const updatedResult = {
                        ...res.data.result,
                        orderCount: item.order_data_count,  // Add item.order to the response
                    };
                    gifts.push(updatedResult); // Collect results
                })
                .catch((err) => {
                    console.error("Error fetching gift details for ID:", item.gift, err);
                });
        });

        // Once all data is fetched, update the state in a single call
        Promise.all([...greetingCardPromises, ...giftPromises]).then(() => {
            setGreetingCardDetails(greetingCards);  // Set all greeting card details at once
            setGiftDetails(gifts);  // Set all gift details at once
        });
    };


 const generateTrackingURL = (courierService, trackingNumber) => {
        if (!trackingNumber) return '';

        const trackingURLs = {
            'Blue Dart': `https://www.bluedart.com/web/guest/trackdartresult?trackFor=0&trackNo=${trackingNumber}`,
            'FedEx': `https://www.fedex.com/fedextrack/?tracknumbers=${trackingNumber}`,
            'DHL': `https://www.dhl.com/in-en/home/tracking/tracking-express.html?submit=1&tracking-id=${trackingNumber}`,
            'DTDC': `https://www.dtdc.in/tracking/tracking_results.asp?Ttype=awb_no&strTType=${trackingNumber}`,
            'India Post': `https://www.indiapost.gov.in/_layouts/15/dop.portal.tracking/trackconsignment.aspx?consignmentnumber=${trackingNumber}`,
            'Delhivery': `https://www.delhivery.com/track/package/${trackingNumber}`,
            'Ekart': `https://ekart.flipkart.com/track?tracking_id=${trackingNumber}`
        };

        return trackingURLs[courierService] || '';
    };

    // Add this handler to auto-generate tracking URL when tracking number changes
    const handleTrackingNumberChange = (trackingNumber) => {
        const generatedURL = generateTrackingURL(deliveryForm.courier_service, trackingNumber);
        setDeliveryForm({
            ...deliveryForm,
            tracking_number: trackingNumber,
            courier_tracking_url: generatedURL
        });
    };

    const handleCourierServiceChange = (courierService) => {
        const generatedURL = generateTrackingURL(courierService, deliveryForm.tracking_number);
        setDeliveryForm({
            ...deliveryForm,
            courier_service: courierService,
            courier_tracking_url: generatedURL
        });
    };


    if (!eventDetails) {
        return <div>Loading...</div>;
    }

    return (
        <div className="wrapper">
            <header>
                <NavigationBar />
            </header>

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-6">
                                <h1 className="m-0 txt_lft">Order Management View</h1>
                            </div>
                            <div className="col-sm-6">
                                <ol className="breadcrumb justify-content-end">
                                    <li className="breadcrumb-item">
                                        <a href="/ordermanagement">
                                            <i className="fa-solid fa-arrow-left-long mr-2" />
                                            Back
                                        </a>
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card card-primary card-outline">
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Event Name</label>
                                                    <div>{eventDetails.event_name}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Event Date</label>
                                                    <div>{eventDetails.event_date}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Event Type</label>
                                                    <div>{eventDetails.event_type}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Greeting Notes</label>
                                                    <div>{eventDetails.greeting_notes}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Phone Number</label>
                                                    <div>{eventDetails.phone_number}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Zip Code</label>
                                                    <div>{eventDetails.zip_code}</div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <div className="form-group">
                                                    <label>Address</label>
                                                    <div>{eventDetails.address}</div>
                                                </div>
                                            </div>

                                            <div className="col-12">
                                                <h5>Greeting Cards</h5>
                                                <div className="row">
                                                    {greetingCardDetails.map((card) => (
                                                        <div key={card._id} className="col-12 col-md-4">
                                                            <div className="card">
                                                                <img
                                                                    src={card.url}
                                                                    alt={card.name}
                                                                    className="card-img-top"
                                                                />
                                                                <div className="card-body">
                                                                    <h5 className="card-title">{card.name}</h5>
                                                                    <p className="card-text">Price: {card.price}</p>
                                                                    <p className="card-text">
                                                                        <strong>Quantity: {card.orderCount}</strong>
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Gifts */}
                                            <div className="col-12">
                                                <h5>Gifts</h5>
                                                <div className="row">
                                                    {giftDetails.map((gift) => (
                                                        <div key={gift._id} className="col-12 col-md-4">
                                                            <div className="card">
                                                                <img
                                                                    src={gift.url}
                                                                    alt={gift.name}
                                                                    className="card-img-top"

                                                                />
                                                                <div className="card-body">
                                                                    <h5 className="card-title">{gift.name}</h5>
                                                                    <p className="card-text">Price: {gift.price}</p>
                                                                    <p className="card-text">Quantity: {gift.orderCount}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                             {/* delivery status update form */}
                            <div className="col-12">
                                <div className="card mt-4">
                                    <div className="card-header">
                                        <h5>Order Status & Shipping Management</h5>
                                    </div>
                                    <div className="card-body">
                                        <div className="row">
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Order Status</label>
                                                    <select
                                                        className="form-control"
                                                        value={deliveryForm.delivery_status}
                                                        onChange={(e) => setDeliveryForm({ ...deliveryForm, delivery_status: e.target.value })}
                                                    >
                                                        <option value="ordered">Ordered</option>
                                                        <option value="packed">Packed</option>
                                                        <option value="shipped">Shipped</option>
                                                        <option value="out_for_delivery">Out for Delivery</option>
                                                        <option value="delivered">Delivered</option>
                                                        <option value="cancelled">Cancelled</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Estimated Delivery Date</label>
                                                    <input
                                                        type="datetime-local"
                                                        className="form-control"
                                                        value={deliveryForm.estimated_delivery_date}
                                                        onChange={(e) => setDeliveryForm({ ...deliveryForm, estimated_delivery_date: e.target.value })}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Tracking Number</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter tracking number"
                                                        value={deliveryForm.tracking_number}
                                                        onChange={(e) => handleTrackingNumberChange(e.target.value)}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Courier Service</label>
                                                    <select
                                                        className="form-control"
                                                        value={deliveryForm.courier_service}
                                                        onChange={(e) => handleCourierServiceChange( e.target.value )}
                                                    >
                                                        <option value="">Select Courier</option>
                                                        <option value="Blue Dart">Blue Dart</option>
                                                        <option value="FedEx">FedEx</option>
                                                        <option value="DHL">DHL</option>
                                                        <option value="DTDC">DTDC</option>
                                                        <option value="India Post">India Post</option>
                                                        <option value="Delhivery">Delhivery</option>
                                                        <option value="Ekart">Ekart</option>
                                                        <option value="Other">Other</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Business Contact</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Business phone/contact"
                                                        value={deliveryForm.business_contact}
                                                        onChange={(e) => setDeliveryForm({ ...deliveryForm, business_contact: e.target.value })}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Pickup Address</label>
                                                    <textarea
                                                        className="form-control"
                                                        rows="2"
                                                        placeholder="Address from where shipped"
                                                        value={deliveryForm.pickup_address}
                                                        onChange={(e) => setDeliveryForm({ ...deliveryForm, pickup_address: e.target.value })}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-4">
                                                <div className="form-group">
                                                    <label>Courier Tracking URL</label>
                                                    <input
                                                        type="url"
                                                        className="form-control"
                                                        placeholder="Enter courier tracking URL"
                                                        value={deliveryForm.courier_tracking_url}
                                                        onChange={(e) => setDeliveryForm({ ...deliveryForm, courier_tracking_url: e.target.value })}
                                                    />
                                                    <small className="form-text text-muted">
                                                        Direct link to track package on courier website
                                                    </small>
                                                </div>
                                            </div>

                                            <div className="col-md-12">
                                                <button
                                                    className="btn btn-primary"
                                                    onClick={updateDeliveryStatus}
                                                >
                                                    Update Order Status
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
}

export default OrderManagementview;
